import React, { useEffect, useRef } from "react";
import { ISnippet, ICustomData } from "../../../../interfaces";
import { COMPONENTS } from "../../../../constants";

class Calculator extends React.Component<ISnippet> {
  snippet: ISnippet;
  snippetData: ICustomData;
  formContentLayouts: object = {};
  formData: FormData;

  constructor(props: ISnippet | Readonly<ISnippet>) {
    super(props);
    this.snippet = {
      custom_data: this.props?.custom_data,
      ...this.props?.data?.attributes
    };

    this.snippet.layout.forEach((item) => {
      if (item.__typename != COMPONENTS.CUSTOM_DATA) {
        this.formContentLayouts[item.name] = item;
      }
    });

    this.state = {};
    this.state["slugs"] = [];

    if (Array.isArray(this.snippet.custom_data)) {
      this.snippet.custom_data.slice(1).map((row, index) => {
        if (Array.isArray(row.items)) {
          row.items.map(
            (rowItem: { ours: { number: any }; theirs: { number: any } }, index: any) => {
              if (rowItem.ours.number) {
                this.state[`${row.slug}-${index}-ours`] = rowItem.ours.number;
              }
              if (rowItem.theirs.number) {
                this.state[`${row.slug}-${index}-theirs`] = rowItem.theirs.number;
              }
            }
          );
        }

        if (row.slug) {
          this.state[`${row.slug}-subtotal-ours`] = "";
          this.state[`${row.slug}-subtotal-theirs`] = "";
          if (row.slug != "total-savings") {
            this.state["slugs"].push(row.slug);
          }
        }
      });
    }

    this.state["canShowTotals"] = false;
    this.state["showTotals"] = false;

    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  checkTotals = () => {
    let fieldsPass = true;
    let index: number,
      length = this.state["slugs"].length;
    for (index = 0; index < length; index += 1) {
      if (
        this.state[`group-${index}-subtotal-ours`] > 0 &&
        this.state[`group-${index}-subtotal-ours`] != null
      ) {
        break;
      }
      fieldsPass = false;
    }
    return fieldsPass;
  };

  getDateTime = () => {
    const today = new Date();
    const date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
    const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    const dateTime = date + " " + time;

    return dateTime;
  };

  handleFocus = (event: { target: { select: () => any } }) => event.target.select();

  handleSubmit = (event: { preventDefault: () => void }) => {
    event.preventDefault();

    if (this.state["canShowTotals"]) {
      this.setState({
        ["showTotals"]: true
      });
    }

    this.formData = new FormData();
    for (const key in this.state) {
      this.formData.append(key, this.state[key]);
    }

    this.formData.append("dateTime", this.getDateTime());

    fetch(this.snippet.custom_data[0].GoogleSheetWebAppScriptUrl, {
      redirect: "follow",
      method: "POST",
      body: this.formData,
      mode: "no-cors"
    })
      // .then(console.log)
      .catch(console.error);
  };

  handleOnChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: string,
    group: string,
    groupIndex: number
  ) => {
    this.setState(
      {
        ["showTotals"]: false,
        [id]: event.target.value
      },
      () => {
        this.updateGroupTotals(group, groupIndex);
      }
    );
  };

  updateTotalSavings = () => {
    let index: number,
      length = this.state["slugs"].length;
    for (index = 0; index < length; index += 1) {
      this.setState({
        [`total-savings-${index}-ours`]: this.state[`group-${index}-subtotal-ours`],
        [`total-savings-${index}-theirs`]: this.state[`group-${index}-subtotal-theirs`]
      });
    }

    let canShowTotals = this.checkTotals();
    this.setState({
      ["canShowTotals"]: canShowTotals
    });
  };

  updateGroupTotals = (group: string, groupIndex: number) => {
    const groupSubtotalOurs = `group-${groupIndex}-subtotal-ours`;
    const groupSubtotalTheirs = `group-${groupIndex}-subtotal-theirs`;
    let oursTotal = 0;
    let theirsTotal = 0;

    for (const key in this.state) {
      if (key.includes(group) && key.includes("-ours") && !key.includes("subtotal")) {
        oursTotal = oursTotal + parseFloat(this.state[key]);
      }
      if (key.includes(group) && key.includes("-theirs") && !key.includes("subtotal")) {
        theirsTotal = theirsTotal + parseFloat(this.state[key]);
      }
    }

    this.setState(
      {
        [groupSubtotalOurs]: oursTotal,
        [groupSubtotalTheirs]: theirsTotal
      },
      () => {
        this.updateTotalSavings();
      }
    );
  };

  TotalButton = () => {
    return (
      <div className="text-center mt-4 mb-3 mx-auto">
        <button className="btn d-inline-block" disabled={!this.state["canShowTotals"]}>
          Click Here To Calculate Your Total Savings
        </button>
      </div>
    );
  };

  TableHeader = (tableHeader: any) => {
    return (
      <div className="header-grid">
        <div className="col-start-2 inputs-grid">
          <div className="label-standard">
            <p>{tableHeader.ours}</p>
          </div>
          <div className="label-standard">
            <p>{tableHeader.theirs}</p>
          </div>
        </div>
      </div>
    );
  };

  DetailItems = (items: any[], slug: string, groupIndex: number, gridClass: string) => {
    return (
      <>
        {Array.isArray(items)
          ? items.map(
              (
                rowItem: {
                  title: any;
                  small: any | null | undefined;
                  ours: { number: any; string: string | undefined };
                  theirs: { number: any; string: string };
                },
                index: any
              ) => {
                return (
                  <div key={index} className={gridClass}>
                    <div className="labels">
                      <p>{rowItem.title}</p>
                    </div>
                    <div className="inputs-grid">
                      <div className="input-wrap">
                        {rowItem.ours.number != null && (
                          <>
                            {rowItem.ours.number != "" && (
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                id={`${slug}-${index}-ours`}
                                onFocus={this.handleFocus}
                                data-group={`${slug}-ours`}
                                onChange={(event) =>
                                  this.handleOnChange(
                                    event,
                                    `${slug}-${index}-ours`,
                                    `${slug}`,
                                    groupIndex
                                  )
                                }
                                value={this.state[`${slug}-${index}-ours`]}
                                className="input-standard"
                              />
                            )}
                            {rowItem.ours.number === "" && (
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                disabled={true}
                                id={`${slug}-${index}-ours`}
                                value={this.state[`${slug}-${index}-ours`]}
                                className="input-standard "
                              />
                            )}
                          </>
                        )}
                        {rowItem.ours.string != null && (
                          <input
                            type="text"
                            disabled={true}
                            value={rowItem.ours.string}
                            className="input-standard"
                          />
                        )}
                      </div>
                      <div className="input-wrap">
                        {rowItem.theirs.number != null && (
                          <>
                            {rowItem.theirs.number != "" && (
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                id={`${slug}-${index}-theirs`}
                                onFocus={this.handleFocus}
                                data-group={`${slug}-theirs`}
                                onChange={(event) =>
                                  this.handleOnChange(
                                    event,
                                    `${slug}-${index}-theirs`,
                                    `${slug}`,
                                    groupIndex
                                  )
                                }
                                value={this.state[`${slug}-${index}-theirs`]}
                                className="input-standard"
                              />
                            )}
                            {rowItem.theirs.number === "" && (
                              <input
                                type="number"
                                min="0"
                                step="0.01"
                                disabled={true}
                                id={`${slug}-${index}-theirs`}
                                value={this.state[`${slug}-${index}-theirs`]}
                                className="input-standard "
                              />
                            )}
                          </>
                        )}
                        {rowItem.theirs.string != null && (
                          <input
                            type="text"
                            disabled={true}
                            value={rowItem.theirs.string}
                            className="input-standard"
                          />
                        )}
                      </div>
                    </div>
                  </div>
                );
              }
            )
          : null}
      </>
    );
  };

  EmptyDetailItems = (items: any[], slug: string, groupIndex: number) => {
    return (
      <>
        {Array.isArray(items)
          ? items.map(
              (
                rowItem: {
                  title: any;
                  small: any | null | undefined;
                  ours: { number: any; string: string | undefined };
                  theirs: { number: any; string: string };
                },
                index: any
              ) => {
                return (
                  <div key={index} className="totals-grid empty-totals-grid">
                    <div className="labels">
                      <p>{rowItem.title}</p>
                    </div>
                    <div className="inputs-grid">
                      <div className="input-wrap">
                        {rowItem.ours.number != null && (
                          <input type="number" disabled={true} className="input-standard " />
                        )}
                      </div>
                      <div className="input-wrap">
                        {rowItem.theirs.number != null && (
                          <input type="number" disabled={true} className="input-standard " />
                        )}
                      </div>
                    </div>
                  </div>
                );
              }
            )
          : null}
      </>
    );
  };

  SubtotalRow = (subtotalLabel: string, slug: string, groupIndex: number) => {
    return (
      <>
        <div className="subtotal-grid pt-1 bg-gray-300">
          <div className="bg-gray-total subtotal-label">
            <p className="text-right">{subtotalLabel && subtotalLabel}</p>
          </div>
          <div className="inputs-grid ">
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                step="0.01"
                id={`${slug}-subtotal-ours`}
                disabled={true}
                value={this.state[`group-${groupIndex}-subtotal-ours`]}
                className="input-standard bg-white font-bold"
              />
            </div>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                step="0.01"
                id={`${slug}-subtotal-theirs`}
                disabled={true}
                value={this.state[`group-${groupIndex}-subtotal-theirs`]}
                className="input-standard bg-white font-bold"
              />
            </div>
          </div>
        </div>
      </>
    );
  };

  componentDidMount() {
    this.state["slugs"].forEach((slug: string, index: number) => {
      if (slug != "total-savings") {
        this.updateGroupTotals(slug, index);
      }
    });
  }

  renderSection({ row, index }) {
    return (
      <div className="container-lg p-responsive relative bg-white" key={`${row.slug}-${index}-row`}>
        <div className="arrow-back" />
        <div className="calc-grid">
          <div className="calculator-info">
            <h2 className="mb-4">{row.heading}</h2>
            <p className="mb-4">{row.description}</p>
          </div>
          <div className="calculator-details">
            {row.tableHeader && this.TableHeader(row.tableHeader)}
            {row.items && row.slug != "total-savings" && (
              <>
                {row.items && this.DetailItems(row.items, row.slug, index, "details-grid")}
                {this.SubtotalRow(row.subtotalLabel, row.slug, index)}
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  unit(title) {
    const matches = title.match(/([^(]*)\s\(([^\)]*)\)/);
    return Object.fromEntries(matches.splice(1, 2).map((v, i) => [i === 0 ? "label" : "unit", v]));
  }

  renderTotals({ row, index }) {
    return (
      <div
        className={`container-lg p-responsive relative totals ${
          this.state.showTotals && "bg-white"
        }`}
        key={`${row.slug}-${index}-row`}
      >
        {!this.state.showTotals && this.TotalButton()}
        {/*
        <pre style={{ textAlign: "left" }}>{JSON.stringify(row, null, "\t")}</pre>
        <pre style={{ textAlign: "left" }}>{JSON.stringify(this.state, null, "\t")}</pre>
        */}
        {this.state.showTotals &&
          ["ours", "theirs"].map((side) => {
            const totals = row.items.map(({ title }, index) => {
              const { label, unit } = this.unit(title);
              const value = this.state[`total-savings-${index}-${side}`];
              const gt = side === "ours" && value < this.state[`total-savings-${index}-theirs`];
              return (
                <div className={`total total-${side}`}>
                  <h4>{label}</h4>
                  <span className={gt ? "gt" : ""}>
                    {unit === "$" && unit}
                    {value}
                    {unit !== "$" && ` ${unit}`}
                  </span>
                </div>
              );
            });

            let rowHeader = row.tableHeader[side];
            if (rowHeader.slice(0, 4) === "http") {
              rowHeader = <img src={rowHeader} />;
            }

            return (
              <section className={side}>
                {side === "ours" && (
                  <div className="total-row header-row">
                    <div />
                    {row.items.map(({ title }) => (
                      <div>{title}</div>
                    ))}
                  </div>
                )}
                <div className="total-row">
                  <div className="product">
                    <span>{rowHeader}</span>
                  </div>
                  {totals}
                </div>
              </section>
            );
          })}
      </div>
    );
  }

  render() {
    let calculatorData = this.snippet.custom_data;
    const rows = Array.isArray(calculatorData) ? calculatorData.slice(1) : null;
    return (
      <div className="calculator py-4">
        <form onSubmit={this.handleSubmit}>
          {rows &&
            rows.map((row, index) => {
              const args = { row, index };
              return index === rows.length - 1 ? this.renderTotals(args) : this.renderSection(args);
            })}
        </form>
      </div>
    );
  }
}

export default Calculator;
